export const WAN_INTERFACE_RULE_FIELD = 'rulePattern';
export const WAN_INCLUDED_PATTERNS_FIELD = 'includedPatterns';
export const WAN_EXCLUDED_PATTERNS_FIELD = 'excludedPatterns';

export const WAN_INTERFACE_CONFIG_API_URL = '/ipm/v1/admin/wanInterfaceConfig';
